import React from "react";
import {
    Select,
    Button,
    Space,
    DatePicker,
    Row,
    Col,
    Dropdown,
    Checkbox,
    Modal,
    Image,
    Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import withRouter from "../withRouter";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import TaxiViolationStore from "../store/TaxiViolationStore";
import moment from "moment";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VehicleStore from "../store/VehicleStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
const { RangePicker } = DatePicker;

dayjs.extend(customParseFormat);

const defaultValue = moment().startOf("day").hour(0).minute(0).second(0);
const { Option } = Select;

let widthAdderFunc = (arr) => {
    let array = arr;
    array.map((val) => {
        if (val.title?.length > 24) {
            val.width = 250;
        } else if (val.title?.length > 15) {
            val.width = 200;
        } else if (val.title?.length > 12) {
            val.width = 150;
        } else if (val.title?.length > 8) {
            val.width = 125;
        } else {
            val.width = 110;
        }
        // console.log(val.title.length)
    });

    return arr;
};
class TaxiViolationReport extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.TaxiViolationStore = new TaxiViolationStore(this);
        this.vehicleStore = new VehicleStore(this);

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            company_name: "",
            listUpdated: 0,
            companyId: "",
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            selectedVehicles: "",
            selectAllVehicles: false,
            modalVisible: false,
            column: "",
            filter: "",
            Notcompany: false,
            Notasset: false,

            selectedColumns: widthAdderFunc([

                {
                    title: context.translate("_VEHICLE_NO_"),
                    dataIndex: "vehicleNo",
                    key: "vehicleNo",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_DRIVER_NAME_"),
                    dataIndex: "driverName",
                    key: "driverName",
                    width: 100,
                    ellipsis: { showTitle: true }
                },

                {
                    title: context.translate("_EVENT_CATEGORY_"),
                    dataIndex: "eventCategory",
                    key: "eventCategory",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_VIOLATION_DESCRIPTION_"),
                    dataIndex: "violationDescription",
                    key: "violationDescription",
                    width: 150,
                    ellipsis: { showTitle: true }
                },


                {
                    title: context.translate("_SHIFT_NUMBER_"),
                    dataIndex: "shiftNo",
                    key: "shiftNo",
                    width: 100,
                    ellipsis: { showTitle: true }
                },


                {
                    title: context.translate("_EVENT_TIME_"),
                    dataIndex: "eventTime",
                    key: "eventTime",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_LATITUDE_"),
                    dataIndex: "latitude",
                    key: "latitude",
                    width: 100,
                    ellipsis: { showTitle: true }
                },
                {
                    title: context.translate("_LONGITUDE_"),
                    dataIndex: "longitude",
                    key: "longitude",
                    width: 100,
                    ellipsis: { showTitle: true }
                },

                {
                    title: context.translate("_VIOLATION_TYPE_"),
                    dataIndex: "violationType",
                    key: "violationType",
                    width: 80,
                    ellipsis: { showTitle: true }
                },

                {
                    title: context.translate("_ACTION_"),
                    dataIndex: "action",
                    width: 30,
                    align: "center",
                    ellipsis: {
                        showTitle: true,
                    },
                    render: (_, record) => {
                        return (
                            <>
                                <Space>

                                    {record.isReleased == 1 ?
                                        <Tooltip title={context.translate("_RELEASED_")} placement="bottom">

                                            <i
                                                className="bi bi-check-circle-fill"
                                                style={{
                                                    fontSize: "15px",
                                                    // cursor: "pointer",
                                                    color: "green",
                                                }}

                                            />
                                        </Tooltip>
                                        :

                                        <Tooltip title={context.translate("_RELEASE_")} placement="bottom">

                                            <i
                                                className="bi bi-send"
                                                style={{
                                                    fontSize: "15px",
                                                    cursor: "pointer",
                                                }}
                                                onClick={async (e) => {
                                                    e.preventDefault();
                                                    console.log(record);
                                                    await this.onRelease(record);
                                                }}
                                            />
                                        </Tooltip>}

                                </Space>
                            </>
                        );
                    },
                }


            ]),
        };
        this.menuProps = {
            items: [
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={Excel}
                            ></Image>
                            {context.translate("_EXPORT_AS_EXCEL_")}
                        </div>
                    ),
                    key: "excel",
                },
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={PDF}
                            ></Image>
                            {context.translate("_EXPORT_AS_PDF_")}
                        </div>
                    ),
                    key: "pdf",
                },
            ],
            onClick: (val) => {
                let result = [];

                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

                    console.log(this.state.fromDate, this.state.toDate);

                    var getData = {
                        companyId: this.state.companyId,
                        vehicleId: this.state.selectedVehicles,
                        interval: this.state.interval,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        colList: result.toString(),
                    };
                    if (val.key == "excel") {
                        // console.log("afd")
                        this.TaxiViolationStore.exportExcel(getData);
                    }
                    if (val.key == "pdf") {
                        this.TaxiViolationStore.exportpdf(getData);
                    }

                }
            },
        };
        this.newColumns = [...this.state.selectedColumns, {
            title: context.translate("_UID_"),
            dataIndex: "uid",
            key: "uid",
            width: 100,
            ellipsis: { showTitle: true }
        }, {
            title: context.translate("_UNIT_NO_"),
            dataIndex: "unitNo",
            key: "unitNo",
            width: 100,
            ellipsis: { showTitle: true }
        }, {
            title: context.translate("_GEO_ID_"),
            dataIndex: "geoId",
            key: "geoId",
            width: 100,
            ellipsis: { showTitle: true }
        }, {
            title: context.translate("_GPS_FIX_"),
            dataIndex: "gpsFix",
            key: "gpsFix",
            width: 100,
            ellipsis: { showTitle: true }
        },
        {
            title: context.translate("_IGNITION_"),
            dataIndex: "ignition",
            key: "ignition",
            width: 100,
            ellipsis: { showTitle: true }
        }, {
            title: context.translate("_QUANTITY_"),
            dataIndex: "quantity",
            key: "quantity",
            width: 100,
            ellipsis: { showTitle: true }
        },
        {
            title: context.translate("_GEO_SPEED_LIMIT_"),
            dataIndex: "geoSpeedLimit",
            key: "geoSpeedLimit",
            width: 100,
            ellipsis: { showTitle: true }
        },
        {
            title: context.translate("_CURRENT_SPEED_"),
            dataIndex: "currentSpeed",
            key: "currentSpeed",
            width: 100,
            ellipsis: { showTitle: true }
        },
        {
            title: context.translate("_CREATED_AT_"),
            dataIndex: "createdAt",
            key: "createdAt",
            width: 100,
            ellipsis: { showTitle: true }
        },];
    }
    onRelease = async (record) => {
        console.log(record)
        const data = {
            vehicleId: record.vehicleId,
            companyId: record.companyId,
            violationDescription: record.violationDescription,
            violationType: record.violationType,
            createdAt: record.createdAt,
            unitNo: record.unitNo,
            Id: record.id,
            uid: record.uid
        }
        this.TaxiViolationStore.releaseCmd(data);
        await this.TaxiViolationStore.loadData({
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            offset: 0,
            limit: 50,
        });
        await this.setState({ loadData: 1 });

    };

    async componentDidMount() {
        if (Number(this.props.getUserData().isadmin) !== -1) {
            console.log(this.props.getUserData().userCompanyId);
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ userId: this.props.getUserData().userId });
            await this.vehicleStore.getVehiclesCompanyId(
                this.props.getUserData().userCompanyId
            );
            await this.setState({ loadData: 1 });
        }
        this.setState({ pageSize: 50 });

        await this.setState({ column: this.state.selectedColumns });
    }

    async handleTableChange(pagination, filters, sorter) {
        //   console.log(pagination);
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.showData();
    }
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        }
    };
    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        await this.setState({ currentPage: 1, companyId: comp?.value });
        await this.setState({ selectedVehicles: "" });
        await this.vehicleStore.getVehiclesCompanyId(comp?.value);
        await this.setState({ listUpdated: 1 });
        console.log(await this.vehicleStore?.getVehiclesUsingCompanyId)

    }


    refreshList = async () => {
        this.setState({ loading: true });
        if (this.state.companyId) {
            await this.TaxiViolationStore.loadData({
                companyId: this.state.companyId,
                vehicleId: this.state.selectedVehicles,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                offset: 0,
                limit: 50,
            });
        }
        this.setState({ loading: false, currentPage: 1 });
    };
    showData = async () => {
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }
        if (!this.state.selectedVehicles) {
            this.setState({ Notasset: true });
        } else {
            this.setState({ Notasset: false });
        }
        if (this.state.companyId && this.state.selectedVehicles) {
            // this.setState({mandatory:false})
            this.setState({ Notcompany: false, Notasset: false });
            await this.TaxiViolationStore.loadData({
                offset: (this.state.currentPage - 1) * this.state.pageSize,
                limit: this.state.pageSize,
                companyId: this.state.companyId,
                vehicleId: this.state.selectedVehicles,
                fromDate: this.state.fromDate,
                toDate: this.state.toDate,
                pageNo: this.state.currentPage,
            });
            await this.setState({ listUpdated: 1 });
        }
    };
    handleAllSelectVehicles = async (e) => {
        if (this.state.selectAllVehicles) {
            const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
                (val) => {
                    return val.vehicleId;
                }
            );
            await this.setState({ selectedVehicles: allVehicles });
        } else {
            await this.setState({ selectedVehicles: [] });
        }
    };

    handleCheckboxChange = async (column) => {
        console.log(column);
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );
            console.log(filtered);
            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
        } else {
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
        }
    };
    render() {

        return (
            <>

                <div className="listHeader">
                    <Row className="listInputRow">
                        <Space>
                            <Col span={16}>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={(value) => this.handleChange(value)}
                                    allowClear={true}
                                    style={{ width: 150 }}
                                    // style={companyInputStyle}
                                    status={this.state.Notcompany ? "error" : false}
                                />
                            </Col>

                            <Col>
                                <Select
                                    className="searchInput"
                                    value={
                                        this.state.selectedVehicles
                                            ? this.state.selectedVehicles
                                            : null
                                    }
                                    onChange={(val) => {
                                        this.setState({ selectedVehicles: val });
                                        this.setState({ Notasset: false });
                                    }}
                                    style={{ width: 150 }}
                                    showSearch
                                    status={this.state.Notasset ? "error" : false}
                                    placeholder={this.context.translate(
                                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                                    )}
                                    filterOption={(inputValue, option) => {
                                        if (option.children) {
                                            return (
                                                option.children
                                                    .toLowerCase()
                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                            );
                                        }
                                    }}
                                >
                                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                                        return (
                                            <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                                        );
                                    })}
                                </Select>
                            </Col>
                            <Col>
                                <RangePicker
                                    placeholder={["From Datetime", "To Datetime"]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400, borderRadius: "25px" }}
                                    onChange={(val) => {
                                        const [start, end] = val;
                                        this.onDateTimeChange([start, end]);
                                    }}
                                    // disabledDate={(current) => {
                                    //     return current && current > dayjs();
                                    // }}
                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [dayjs().startOf("day"), dayjs()],
                                    }}
                                    defaultValue={[dayjs().startOf("day"), dayjs()]}
                                />
                            </Col>

                            <Col>
                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ currentPage: 1, pageSize: 50 });
                                        await this.showData();
                                    }}
                                >
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                            </Col>
                        </Space>

                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={8}
                        >
                            <Space>
                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {this.context.translate("_COLUMNS_")}
                                </Button>
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            marginInlineEnd: "20px",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>

                                <Dropdown
                                    disabled={
                                        this.TaxiViolationStore?.sensorReport?.length > 0
                                            ? false
                                            : true
                                    }
                                    menu={this.menuProps}
                                >
                                    <Button className="downloadExcelButton">
                                        <Image
                                            style={{
                                                height: 18,
                                                width: "auto",
                                            }}
                                            src={downloadIcon}
                                        />
                                    </Button>
                                </Dropdown>
                            </Space>
                        </Col>
                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        // title="Select Columns"
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.TaxiViolationStore?.total}
                        columns={this.state.column}
                        dataSource={this.TaxiViolationStore?.sensorReport}

                        loading={this.TaxiViolationStore?.loading}
                        onChange={this.handleTableChange}
                        scroll={{
                            x: 100,
                        }}
                    />
                </div>
            </>
        );
    }
}
TaxiViolationReport.contextType = StoreContext;
export default observer(withRouter(TaxiViolationReport));
